import request from '@/plugin/axios';

export default {
  getStudentCardNumber(payload) {
    const params = {
      ...payload
    };
    return request({
      url: '/baseApi/studentCardNumber/getStudentList',
      method: 'get',
      params
    });
  },
  updateCardNumberForStudent(payload) {
    return request({
      url: '/baseApi/studentCardNumber/updateCardNumber',
      method: 'post',
      data: payload
    });
  },
  deleteCardNumberForStudent(payload) {
    return request({
      url: '/baseApi/studentCardNumber/delCardNumber',
      method: 'post',
      data: payload
    });
  },
  getTeacherCardNumber(payload) {
    const params = {
      ...payload
    };
    return request({
      url: '/baseApi/teacherCardNumber/getTeacherList',
      method: 'get',
      params
    });
  },
  updateCardNumberForTeacher(payload) {
    return request({
      url: '/baseApi/teacherCardNumber/updateCardNumber',
      method: 'post',
      data: payload
    });
  },
  deleteCardNumberForTeacher(payload) {
    return request({
      url: '/baseApi/teacherCardNumber/delCardNumber',
      method: 'post',
      data: payload
    });
  },
  getClassByUser(payload) {
    const params = {
      ...payload
    };
    return request({
      url: '/baseApi/class/getClassByUser',
      method: 'get',
      params
    });
  }
};
